import { render, staticRenderFns } from "./room-select-button.vue?vue&type=template&id=5ece5ff1&"
import script from "./room-select-button.vue?vue&type=script&lang=js&"
export * from "./room-select-button.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports